import api from "services/applications";

const state = {
  all: [],
  selected: {},
  filter: "all",
  pagination: [],
  totalPages: "",
  currentPage: "",
  searchQuery: {
    search: "",
    postcode: "",
    applicationBegin: "",
    applicationEnd: "",
    registrationBegin: "",
    registrationEnd: "",
    acceptedBegin: "",
    acceptedEnd: "",
    registeredBegin: "",
    registeredEnd: "",
    feesBegin: "",
    feesEnd: "",
    registrationStubMonth: null,
    registrationStubYear: null,
    schools: "",
    campuses: "",
    type: "",
    schoolingType: "",
    interestedType: "",
    grade: "",
    year: "",
    years: "",
    process: "",
    visa: "",
    no_visa_request: "",
    alternance: "",
    sponsoring: "",
    high_level_athlete: "",
    interview_undocumented: "",
    banned: null,
    fileStatus: null,
    financeStatus: null,
    status: null,
    funding: null,
    staffs: null,
    staff_reminder: null,
    no_schedule: null,
    no_interview: null,
    with_schedule: null,
    staff_schedule: null,
    staff_remind: null,
    scheduleBegin: null,
    scheduleEnd: null,
    trainings: null,
    training_options: null,
    origin: null,
    parcourSupConfirmation: null,
    training_paces: null,
    schoolingOffers: null,
    schoolingOffersStatus: null,
    nb_comments: null,
    events: null,
    jpo: null,
    involvedEvents: null,
    duplicates: false,
    finances: false,
    file_list: "",
    file_from: "",
    file_to: "",
    engagement_score: '',
    sort_by: 'created_at',
    sort_direction: 'desc',
    additionalDocuments: null,
    emailVerified: null,
  },
  selectedFilters: {
    applicationBegin: null,
    applicationEnd: null,
    registrationBegin: null,
    registrationEnd: null,
    acceptedBegin: null,
    acceptedEnd: null,
    registeredBegin: null,
    registeredEnd: null,
    feesBegin: null,
    feesEnd: null,
    registrationStubMonth: null,
    registrationStubYear: null,
    fileStatus: null,
    financeStatus: null,
    status: null,
    funding: null,
    process: null,
    visa: null,
    banned: null,
    no_visa_request: null,
    alternance: null,
    origin: null,
    parcourSupConfirmation: null,
    sponsoring: null,
    high_level_athlete: null,
    interview_undocumented: null,
    type: null,
    schoolingType: null,
    interestedType: null,
    grade: null,
    year: null,
    years: null,
    staffs: null,
    staff_reminder: null,
    no_schedule: null,
    no_interview: null,
    with_schedule: null,
    staff_schedule: null,
    staff_remind: null,
    scheduleBegin: null,
    scheduleEnd: null,
    schools: null,
    campuses: null,
    trainings: null,
    training_options: null,
    training_paces: null,
    schoolingOffers: null,
    schoolingOffersStatus: null,
    nb_comments: null,
    events: null,
    jpo: null,
    involvedEvents: null,
    file_list: null,
    file_from: null,
    file_to: null,
    engagement_score: '',
    additionalDocuments: null,
    emailVerified: null,
  },
  status: null
};

const getters = {
  getAllApplications: state => state.all,
  getSelectedUser: state => state.selected,
  getSearchQuery: state => state.searchQuery,
  getSelectedFilters: state => state.selectedFilters,
  getStatus: state => state.status,
  totalPages(state) {
    return state.pagination.total_pages;
  },
  currentPage(state) {
    return state.pagination.current_page;
  },
  pagination(state) {
    return state.pagination;
  }
};

const mutations = {
  fetchApplications: (state, payload) => {
    state.all = payload.users;
    state.pagination = payload.meta.pagination;
    const { total, limit, skip } = state.pagination;
    state.totalPages = Math.ceil(total / limit);
    state.currentPage = Math.ceil((skip - 1) / limit) + 1;
  },
  selectApplication: (state, payload) => {
    state.selected = payload;
  },
  resetSearch: state => {
    state.selectedFilters = {
      applicationBegin: null,
      applicationEnd: null,
      feesBegin: null,
      feesEnd: null,
      registrationStubMonth: null,
      registrationStubYear: null,
      registrationBegin: null,
      registrationEnd: null,
      acceptedBegin: null,
      acceptedEnd: null,
      registeredBegin: null,
      registeredEnd: null,
      fileStatus: null,
      financeStatus: null,
      status: null,
      funding: null,
      process: null,
      visa: null,
      banned: null,
      no_visa_request: null,
      alternance: null,
      sponsoring: null,
      high_level_athlete: null,
      interview_undocumented: null,
      type: null,
      schoolingType: null,
      interestedType: null,
      grade: null,
      year: null,
      years: null,
      staffs: null,
      staff_reminder: null,
      no_schedule: null,
      no_interview: null,
      with_schedule: null,
      staff_schedule: null,
      staff_remind: null,
      scheduleBegin: null,
      scheduleEnd: null,
      schools: null,
      campuses: null,
      trainings: null,
      training_options: null,
      schoolingOffers: null,
      schoolingOffersStatus: null,
      nb_comments: null,
      events: null,
      jpo: null,
      involvedEvents: null,
      file_list: null,
      file_from: null,
      file_to: null,
      engagement_score: '',
      additionalDocuments: null,
      emailVerified: null,
    };

    state.searchQuery = {
      search: "",
      postcode: "",
      applicationBegin: "",
      applicationEnd: "",
      registrationBegin: "",
      registrationEnd: "",
      acceptedBegin: "",
      acceptedEnd: "",
      registeredBegin: "",
      registeredEnd: "",
      feesBegin: "",
      feesEnd: "",
      registrationStubMonth: null,
      registrationStubYear: null,
      schools: "",
      campuses: "",
      type: "",
      schoolingType: "",
      interestedType: "",
      grade: "",
      year: "",
      years: "",
      process: "",
      visa: "",
      no_visa_request: "",
      alternance: "",
      sponsoring: "",
      high_level_athlete: "",
      interview_undocumented: "",
      banned: null,
      fileStatus: null,
      financeStatus: null,
      status: null,
      funding: null,
      staffs: null,
      staff_reminder: null,
      no_schedule: null,
      no_interview: null,
      with_schedule: null,
      staff_schedule: null,
      staff_remind: null,
      scheduleBegin: null,
      scheduleEnd: null,
      trainings: null,
      training_options: null,
      schoolingOffers: null,
      schoolingOffersStatus: null,
      events: null,
      jpo: null,
      involvedEvents: null,
      duplicates: false,
      finances: false,
      file_list: "",
      file_from: "",
      file_to: "",
      engagement_score: '',
      sort_by: 'created_at',
      sort_direction: 'desc',
      additionalDocuments: null,
      emailVerified: null,
    };
  },
  setStatus: (state, payload) => {
    state.status = payload.status;
  },
  setScholarYear: (state, year) => {
    state.selectedFilters.year = year;
  },
};

const actions = {
  async fetchApplications({ commit }, query) {
    const payload = await api.search(query);
    if ((await payload.status) === 200) {
      commit("fetchApplications", await payload.data);
    }
    commit("setStatus", await payload);
  },
  async fetchScheduleApplications({ commit }, query) {
    const payload = await api.searchToSchedules(query);
    if ((await payload.status) === 200) {
      commit("fetchApplications", await payload.data);
    }
    commit("setStatus", await payload);
  },
  async selectApplication({ commit }, id) {
    const payload = (await api.showApplication(id)).data;
    commit("selectApplication", await payload);
  },
  resetSearch({ commit }) {
    commit("resetSearch");
  },
  setScholarYear({ commit }, query) {
    commit("setScholarYear", query);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
